import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { DialogFooterModule } from '@ruby/shared/dialogs/dialog-footer/dialog-footer.module';
import { DialogHeaderModule } from '@ruby/shared/dialogs/dialog-header/dialog-header.module';
import { DiversionsCompleteDialog } from '@ruby/shared/dialogs/diversions/diversions-complete/components/diversions-complete.dialog';
import { DiversionsCompleteContainer } from '@ruby/shared/dialogs/diversions/diversions-complete/containers/diversions-complete.container';
import { DirectivesModule } from '@ruby/shared/directives/directives.module';

@NgModule({
  declarations: [
    DiversionsCompleteDialog,
    DiversionsCompleteContainer
  ],
  imports: [
    CommonModule,
    DirectivesModule,
    DialogHeaderModule,
    DialogFooterModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    ReactiveFormsModule
  ],
  exports: [
    DiversionsCompleteContainer
  ]
})
export class DiversionsCompleteModule {}
